<template>
  <div>
    <el-row style="height: 60px; line-height: 60px">
      <!--我的稿件    +  提交新稿件 -->
      <el-col
        :span="12"
        style="text-align: left; font-size: 20px; color: #0a666b"
      >
        <span class="el-icon-guide" style="font-size: 22px"></span>
        稿件列表
      </el-col
      >
    </el-row>
    <el-row style="background-color: white; padding-top: 20px">
      <!--稿件搜索 -->
      <el-form :inline="true" :model="search" label-width="auto">
        <el-form-item label="类型筛选">
          <el-select v-model="search.category" placeholder="稿件类型">
            <el-option
              v-for="(item, index) in categoryOptions"
              :key="index"
              :value="item.value"
              :label="item.label"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="标题 ">
          <el-input v-model="search.title" placeholder="标题"></el-input>
        </el-form-item>
        <el-form-item label="稿件状态">
          <el-select v-model="search.manuscriptStatus" placeholder="稿件状态">
            <el-option
              v-for="item in manuscriptStatusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="时间排序">
          <el-select v-model="search.timeSort" placeholder="时间排序">
            <el-option
              v-for="item in timeSortOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button
            style="background-color: #0a666b; color: white; border: none"
            @click="findAllManuScript()"
          >搜索
          </el-button
          >
        </el-form-item>
      </el-form>
    </el-row>
    <!--稿件列表 -->
    <el-row v-if="manuscriptsList.length === 0">
      <el-col :span="24">
        <el-empty
          description="暂无内容"
          style="height: 900px; background-color: white"
        ></el-empty>
      </el-col>
    </el-row>
    <el-row style="height: 900px" v-else>
      <el-col :span="24" style="margin-top: 10px">
        <el-card
          class="box-card"
          shadow="hover"
          v-for="(item, index) in manuscriptsList"
          :key="index"
        >
          <div slot="header" class="left clearfix">
            <span
              class="el-icon-collection-tag"
              style="
                height: 10px;
                line-height: 10px;
                color: #0a666b;
                float: left;
              "
            >&nbsp;&nbsp;</span
            >
            <span
              style="
                height: 10px;
                line-height: 10px;
                float: left;
                color: #0a666b;
                font-weight: 900;
              "
            >《{{ item.title }}》</span
            >
          </div>
          <el-row>
            <el-col :span="22">
              <el-row>
                <el-col
                  :span="12"
                  style="text-align: left; margin-top: 10px"
                  class="exceed"
                ><span
                  style="color: #0a666b"
                  class="el-icon-user-solid"
                ></span
                >&nbsp;&nbsp;作者:&nbsp;&nbsp;
                  {{ item.authorInfo.map((item) => item.name).join(",") }}
                </el-col>
                <el-col
                  :span="12"
                  style="text-align: left; margin-top: 10px"
                  class="exceed"
                ><span
                  style="color: #0a666b"
                  class="el-icon-s-opportunity"
                ></span
                >&nbsp;&nbsp;稿件类型:&nbsp;&nbsp;

                  {{ item.category }}
                </el-col>

                <el-col
                  :span="12"
                  class="exceed"
                  style="text-align: left; margin-top: 10px"
                ><span
                  style="color: #0a666b"
                  class="el-icon-s-promotion"
                ></span
                >&nbsp;&nbsp;关键词:&nbsp;&nbsp;{{
                    item.manuscriptKeywords
                  }}
                </el-col
                >
                <el-col
                  :span="12"
                  class="exceed"
                  style="text-align: left; margin-top: 10px"
                ><span
                  style="color: #0a666b"
                  class="el-icon-s-operation"
                ></span
                >&nbsp;&nbsp;摘要:&nbsp;&nbsp;{{ item.abstracts }}
                </el-col
                >
              </el-row>
            </el-col>
            <el-col
              :span="2"
              class="full-height-col mediate"
              v-if="item.editorStatus == 'unreviewed'"
            >
              <el-button
                type="primary"
                style="background-color: #09666c; border: none"
                @click="detail(item.flag)"
              >待审核
              </el-button
              >
            </el-col>
            <el-col
              :span="2"
              class="full-height-col mediate"
              v-if="item.editorStatus == 'second_refuse'"
            >
              <el-button
                type="primary"
                style="background-color: #09666c; border: none"
                @click="detail(item.flag)"
              >二审驳回
              </el-button
              >
            </el-col>
            <el-col
              :span="2"
              class="full-height-col mediate"
              v-else-if="item.editorStatus == 'second_unreviewed'"
            >
              <el-button type="warning" @click="detail(item.flag)"
              >评审中
              </el-button
              >
            </el-col>
            <el-col
              :span="2"
              class="full-height-col mediate"
              v-else-if="item.editorStatus == 'refuse'"
            >
              <el-button type="error" @click="detail(item.flag)"
              >一审驳回
              </el-button
              >
            </el-col>
            <el-col
              :span="2"
              class="full-height-col mediate"
              v-else-if="item.editorStatus == 'success'"
            >
              <el-button type="success" @click="detail(item.flag)"
              >已发布
              </el-button
              >
            </el-col>
          </el-row>
        </el-card>

        <br/>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="10"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageTotal"
        >
        </el-pagination>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import {findManuscriptByChargeEmail} from '@/api/data'

export default {
  name: 'editorList',
  components: {},
  data() {
    return {
      userInfo: null,
      currentPage: 1,
      pageNum: 1,
      pageSize: 10,
      pageTotal: 0,
      search: {
        category: '',
        title: '',
        manuscriptStatus: '',
        timeSort: 'desc'
      },
      manuscriptsList: [],
      manuscriptStatusOptions: [
        {value: '', label: '全部'},
        {value: 'unreviewed', label: '未审核'},
        {value: 'refuse', label: '已拒绝'},
        {value: 'success', label: '已通过'}
      ],
      timeSortOptions: [
        {value: '', label: '全部'},
        {value: 'desc', label: '倒序'},
        {value: 'asc', label: '正序'}
      ],
      categoryOptions: [
        {value: '', label: '全部'},
        {value: '生理实验', label: '生理实验'},
        {value: '语言变异', label: '语言变异'},
        {value: '语音格局', label: '语音格局'},
        {value: '声学实验', label: '声学实验'},
        {value: '心理实验', label: '心理实验'},
        {value: '神经科学', label: '神经科学'},
        {value: '建模仿真', label: '建模仿真'},
        {value: '理论探索', label: '理论探索'},
        {value: '评述推介', label: '评述推介'},
        {value: '学术资讯', label: '学术资讯'}
      ]
    }
  },
  methods: {
    detail(flag) {
      window.manuscriptsFlag = flag
      this.$router.push('/editorDetail?flag=' + flag)
    },
    findAllManuScript() {
      findManuscriptByChargeEmail({
        chargeEmail: this.userInfo.email,
        category: this.search.category,
        title: this.search.title,
        manuscriptStatus: this.search.manuscriptStatus,
        timeSort: this.search.timeSort,
        current: this.pageNum,
        size: this.pageSize
      }).then((res) => {
        console.log(res)
        this.pageTotal = res.data.result.total
        this.manuscriptsList = res.data.result.records
        this.manuscriptsList.forEach(item => {
          item.authorInfo = item.authorInfo.filter(el => el !== null)
        })
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
    },

    handleCurrentChange(val) {
      this.pageNum = val
      this.findAllManuScript()
    }
  },
  mounted() {
    let userInfo = this.$cookie.getCookie('userInfo')
    console.log('editor' + userInfo)
    // if (userInfo == null || userInfo.type != "责任编辑") {
    //   this.$message({
    //     message: "请先登录！",
    //     type: "error",
    //   });
    //   this.$router.push("index");
    // }
    this.userInfo = userInfo
    this.findAllManuScript()
  }
}
</script>

<style scoped>
.box-card {
  width: 100%;
  border-radius: 10px;
  margin-bottom: 10px;
}

.exceed {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>



// WEBPACK FOOTER //
// src/view/editor/editorList.vue